module.exports = __webpack_public_path__ + "media/images/app/how-it-works/subscription-box-mobile-0a4ffdee047e9a00837515a633d1aa9c.webp";